import { h } from 'preact';

import { getHubThundrData, getCopy, getPageName } from 'utils/thundr';

import EditorContent from 'components/editor/content';

export default class HubPageEditor extends EditorContent {
	componentDidMount() {
		super.componentDidMount?.();
		this.loadThundrData();
	}

	async loadThundrData() {
		const thundrData = await getHubThundrData();
		this.setState({ thundrData });
	}

	getCopy(name, defaultValue) {
		return getCopy(this.state.thundrData, name, defaultValue);
	}

	getPageName(id, defaultValue) {
		return getPageName(this.state.thundrData, id, defaultValue);
	}
}